"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationMessage = ValidationMessage;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = require("../Icon");

var _excluded = ["className", "children", "testId"];
var styles = {
  "ValidationMessage": "ValidationMessage__ValidationMessage___3_rEq",
  "ValidationMessage__icon": "ValidationMessage__ValidationMessage__icon___3HPCh",
  "ValidationMessage__text": "ValidationMessage__ValidationMessage__text___8FBj5"
};

function ValidationMessage(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-validation-message' : _ref$testId,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classNames = (0, _classnames["default"])(styles['ValidationMessage'], className);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, otherProps, {
    className: classNames,
    "data-test-id": testId
  }), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: "ErrorCircleOutline",
    className: styles['ValidationMessage__icon'],
    color: "negative"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: styles['ValidationMessage__text']
  }, children));
}